import { media } from 'components/utils/breakpoints'

import { BoxProps } from '@chakra-ui/react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { LayoutProps } from './interfaces'

const layoutWidth = (grid: number | 'auto') => {
    return css`
        ${grid === 'auto'
            ? `width: auto; flex: 0 0 auto;`
            : `max-width: calc((${grid} / 12) * 100%)!important`};
    `
}

export const Container = styled.div<Omit<LayoutProps & BoxProps, 'type'>>`
    width: 100%;
    margin-inline: auto;
    ${({ full }) =>
        !full &&
        css`
            @media ${media('sm')} {
                max-width: 560px;
            }
            @media ${media('md')} {
                max-width: 740px;
            }
            @media ${media('lg')} {
                max-width: 960px;
            }
            @media ${media('xl')} {
                max-width: 1040px;
            }
            @media ${media('2xl')} {
                max-width: 1200px;
            }
        `}
`

export const Row = styled.div<Omit<LayoutProps, 'type'>>`
    --gutter-x: ${({ gutter }) => css`calc(1rem * ${gutter?.x || 2})`};
    --gutter-y: ${({ gutter }) => css`calc(1rem * ${gutter?.y || 0})`};
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--gutter-y));
    margin-inline: calc(-0.5 * var(--gutter-x));

    > * {
        width: 100%;
        max-width: 100%;
        padding-inline: calc(var(--gutter-x) * 0.5);
        margin-top: var(--gutter-y);
    }

    & + & {
        margin-top: ${({ gutter }) => css`calc(1rem * ${gutter?.y || 1})`};
    }
`

export const Col = styled.div<Omit<LayoutProps, 'type'>>`
    flex: ${({ layout }) => (layout ? '0 0 auto' : '1 0 0%')};
    ${({ layout }) => layout?.base && layoutWidth(layout.base)};

    @media ${media('sm')} {
        ${({ layout }) => layout?.sm && layoutWidth(layout.sm)};
    }
    @media ${media('md')} {
        ${({ layout }) => layout?.md && layoutWidth(layout.md)};
    }
    @media ${media('lg')} {
        ${({ layout }) => layout?.lg && layoutWidth(layout.lg)};
    }
    @media ${media('xl')} {
        ${({ layout }) => layout?.xl && layoutWidth(layout.xl)};
    }
    @media ${media('2xl')} {
        ${({ layout }) => layout?.xxl && layoutWidth(layout.xxl)};
    }
`
